module.exports = __webpack_public_path__ + "img/logoDarkUse.bc31376b.png";